import {fetch} from "../../../utils/dataAccess";

export function creationData(inventoryId) {
    return new Promise((resolve, reject) =>  {
        fetch("/w_m_s_tasks/getCreationFormData?inventoryId="+inventoryId)
            .then((response => {
                response.json().then(retrieve => {
                    resolve(retrieve)
                })
            }))
            .catch(error => reject(error))
    })
}

export function createNewMission(data) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_tasks/create/", {
            method: "POST",
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify({
                inventory: `/inventories/${data.inventory.id}`,
                maxItems: data.quantity,
                data: data
            })
        })
            .then((response) => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}